/**
 * Dados estruturados (schema.org) para o Google entender a página.
 *
 * `dangerouslySetInnerHTML` é o jeito correto aqui: o conteúdo é JSON gerado
 * por nós, não entrada de usuário. Mesmo assim, `</script>` é escapado — um
 * nome de produto contendo essa sequência fecharia a tag cedo e injetaria
 * markup na página.
 */
export function JsonLd({ dados }: { dados: Record<string, unknown> }) {
  const json = JSON.stringify(dados).replace(/</g, '\u003c')
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />
}
